import React, { Component } from "react";
import { connect } from "react-redux";
import { Group, Image } from "react-konva";
import { attachAccessory } from "../../actions/endcap-actions";
import colorString from "color-string";
import Konva from "konva";
import Flamp from "./flamp";

/* loading the chamber drawing image */
const endcapImgURL = require("../../media/chamber-endcap.png");
const endcapImg = new window.Image();
endcapImg.src = endcapImgURL;

const endcapIsolatorImgURL = require("../../media/chamber-endcap-isolator.png");


const endcapIsolatorImg = new window.Image();
endcapIsolatorImg.src = endcapIsolatorImgURL;


const endcapIsolatorFlampImgURL = require("../../media/flamp.svg");
const endcapIsolatorFlampImg = new window.Image();
endcapIsolatorFlampImg.src = endcapIsolatorFlampImgURL;


class Endcap extends Component {
    componentDidMount() {
        if (this.props.active) {
        }
    }

    setAccessoryColoring( endcapNode ) {
        if (
            this.props.active &&
            this.props.accessory &&
            this.props.accessory.id &&
            this.props.accessory.id !== "none" &&
            endcapNode
        ) {
            /* cache the image */
            endcapNode.cache();
            /* get rgb array from accessory color */
            let rgb = colorString.get.rgb(this.props.accessory.color);
            /* set the green red and blue of the image */
            endcapNode.red(rgb[0]);
            endcapNode.green(rgb[1]);
            endcapNode.blue(rgb[2]);
        } else if (this.props.active && endcapNode) {
            endcapNode.clearCache();
        }
    }

    handleOnMouseEnter() {
        let opacityValue = this.props.enableTransparency ? 1 : -.5;
        if (this.props.active) {
            this.endcapNode.opacity(opacityValue);
        }
        this.endcapNode.getLayer().batchDraw();
    }

    handleOnMouseLeave() {
        let opacityValue = this.props.enableTransparency ? 0.5 : 1;
        if (this.props.active) {
            this.endcapNode.opacity(opacityValue);
        } else {
            this.endcapNode.fill("transparent");
        }
        this.endcapNode.getLayer().batchDraw();
    }

    renderEndcapElement() {
        /* if active render a chamber image, otherwise an empty rectangle */
        /* check if this chamber must be selected */
        let opacityValue = this.props.enableTransparency ? 0.5 : 1;

        if (this.props.active) {
            return (
                <React.Fragment>
                    <Image
                        id={`${this.props.row}-${this.props.col}-${this.props.position}`}
                        name="endcap"
                        image={this.props.isIsolator ? endcapIsolatorImg : endcapImg}
                        height={this.props.height}
                        width={this.props.width}
                        stroke={this.props.enableDebuging ? "red" : ""}
                        strokeWidth={this.props.enableDebuging ? 2 : 0}
                        opacity={opacityValue}
                        ref={node => {
                            this.endcapNode = node;
                        }}
                        filters={[Konva.Filters.RGB]}
                    />
                    <Flamp {...this.props} />
                </React.Fragment>
            );
        }
    }

    render() {
        return (
            <Group
                height={this.props.height}
                width={this.props.width}
                rotation={this.props.rotation}
                x={this.props.x + this.props.installedOffSet}
                y={this.props.y}
                ref={node => {
                    this.groupNode = node;
                }}>
                {this.renderEndcapElement()}
            </Group>
        );
    }
}

const mapStateToProps = state => {
    return {
        drawingMode: state.globals.drawingMode,
        enableDebuging: state.globals.enableDebuging,
        enableTransparency: state.globals.enableTransparency
    };
};

const mapDispatchToProps = {
    attachAccessory
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Endcap);



// WEBPACK FOOTER //
// ./src/components/Drawings/endcap.js